// @types
import { ConfigStates, ThemeDirection } from '@/types/config';

// Re-export types
export { ThemeDirection } from '@/types/config';

/***************************  THEME ENUM  ***************************/

export enum ThemeMode {
  LIGHT = 'light',
  DARK = 'dark',
  SYSTEM = 'system'
}

/***************************  THEME CONSTANT  ***************************/

export const DRAWER_WIDTH = 254;
export const MINI_DRAWER_WIDTH = 76 + 1; // 1px - for right-side border

/***************************  CONFIG  ***************************/

const config: ConfigStates = {
  themeDirection: ThemeDirection.LTR,
  miniDrawer: false
};

export default config;
